import Swiper from 'swiper/swiper-bundle';
import gsap from "gsap";

function partnerLogo() {    

    var swiper = new Swiper(".logo-slider", {
        spaceBetween: 0,
        centeredSlides: true,
        speed: 3000,
        autoplay: {
            delay: 1,
        },
        loop: true,
        slidesPerView:'auto',
        allowTouchMove: false
    });
}

export default partnerLogo;

//module.exports = bannerSlider;